import { $, $$, aviso, esc, escribir, fecha, limpiar, noContesto, num, pedir, rpc, sb, pedirTodo, ordenarPor } from './nucleo';
import { cargarProductos } from './catalogo';

// =====================================================================
//  PRECIOS  (0022)
// =====================================================================
//  Un precio no se edita: se agrega otro con la fecha desde la que rige.
//  Esta pantalla arma la lista de lo que cambió y la manda de una sola
//  vez; la base no distingue entre "cambié uno" y "cambié doscientos".
let PRECIOS = [];        // v_precios
let NUEVOS  = {};        // producto_id -> precio tecleado, todavía sin guardar

export async function cargarPrecios(){
  const { data, error } = await pedirTodo(() => sb.from('v_precios').select('*')
    .eq('activo', true), { por: 'producto_id', orden: ordenarPor('codigo', 'producto_id') });
  if (error){ aviso('#prMsg','bad', error.message); return; }
  PRECIOS = data || [];

  const cats = [...new Set(PRECIOS.map(p => p.categoria).filter(Boolean))].sort();
  const elegida = $('#prCat').value;
  $('#prCat').innerHTML = '<option value="">Todas las categorías</option>' +
    cats.map(c => `<option value="${esc(c)}">${esc(c)}</option>`).join('');
  if (elegida) $('#prCat').value = elegida;

  pintarPrecios();
  pintarProgramados();
  cargarListaPublica();
}

function preciosFiltrados(){
  const cat = $('#prCat').value;
  const q   = ($('#prBusca').value || '').toLowerCase();
  return PRECIOS.filter(p =>
    (!cat || p.categoria === cat) &&
    (!q || [p.codigo, p.descripcion, p.linea, p.color, p.subcategoria]
            .some(v => (v||'').toLowerCase().includes(q))));
}

function pintarPrecios(){
  const f = preciosFiltrados();
  $('#tblPrecios').innerHTML = f.map(p => `
    <tr><td class="mono">${esc(p.codigo)}</td>
        <td>${esc(p.descripcion)}</td>
        <td>${esc(p.categoria ?? '—')}</td>
        <td class="num">${p.precio_vigente != null
              ? num(p.precio_vigente)
              : '<span class="chip c-warn">sin precio</span>'}</td>
        <td class="num"><input type="number" step="0.01" min="0" style="max-width:6.471rem"
             data-prod="${p.producto_id}" value="${NUEVOS[p.producto_id] ?? ''}"
             placeholder="—"></td>
        <td>${p.precio_programado != null
              ? `<span class="chip c-pen">${num(p.precio_programado)}</span>
                 <span class="hint">desde ${esc(fecha(p.programado_desde))}</span>`
              : '<span class="hint">—</span>'}</td>
        <td class="num">${p.disponible != null ? num(p.disponible)
              //  0057 (pendiente 66): sin \`stock.ver\` la base devuelve null, no cero
              //  (\`num(null)\` pintaría 0, que es «no hay»). Un null SÓLO llega sin
              //  ese permiso: no hace falta un segundo texto.
              : '<span class="hint" title="No se sabe: te falta el permiso stock.ver">—</span>'}</td></tr>
  `).join('') || '<tr><td colspan="7" class="vacio">Nada con ese filtro</td></tr>';

  $$('#tblPrecios input[data-prod]').forEach(i => {
    i.oninput = () => {
      const id = Number(i.dataset.prod);
      if (i.value === '') delete NUEVOS[id]; else NUEVOS[id] = Number(i.value);
      resumenPrecios();
    };
  });
  resumenPrecios();
}

function resumenPrecios(){
  const n = Object.keys(NUEVOS).length;
  $('#prResumen').textContent = `${preciosFiltrados().length} ${preciosFiltrados().length === 1 ? 'producto' : 'productos'} a la vista · `
    + (n ? `${n} con precio nuevo sin guardar` : 'nada tecleado todavía');
}

$('#prCat').onchange  = pintarPrecios;
$('#prBusca').oninput = pintarPrecios;
$('#prCuando').onchange = () => {
  const prog = $('#prCuando').value === 'programado';
  $('#lblPrFecha').classList.toggle('oculto', !prog);
  if (prog && !$('#prFecha').value){
    // Por defecto, mañana a las 8: es el caso real de todos los días.
    const d = new Date(); d.setDate(d.getDate()+1); d.setHours(8,0,0,0);
    $('#prFecha').value = new Date(d.getTime() - d.getTimezoneOffset()*60000)
      .toISOString().slice(0,16);
  }
};

$('#btnPrMasivo').onclick = e => {
  e.preventDefault();
  limpiar('#prMsg');
  const v = $('#prMasivo').value;
  if (v === ''){ aviso('#prMsg','bad','Escribí el precio que querés aplicar.'); return; }
  preciosFiltrados().forEach(p => NUEVOS[p.producto_id] = Number(v));
  pintarPrecios();
  aviso('#prMsg','ok', (preciosFiltrados().length === 1 ? 'Quedó 1 producto con '
                       : `Quedaron ${preciosFiltrados().length} productos con `)
    + `${num(Number(v))}. Todavía no se guardó nada: revisá y apretá Guardar.`);
};

$('#btnPrLimpiar').onclick = e => {
  e.preventDefault(); NUEVOS = {}; limpiar('#prMsg'); pintarPrecios();
};

$('#btnPrGuardar').onclick = async e => {
  e.preventDefault();
  limpiar('#prMsg');
  const items = Object.entries(NUEVOS)
    .filter(([,v]) => Number.isFinite(v))
    .map(([id, precio]) => ({ producto_id: Number(id), precio: Number(precio) }));
  if (!items.length){ aviso('#prMsg','bad','No hay ningún precio nuevo para guardar.'); return; }

  let desde = null;
  if ($('#prCuando').value === 'programado'){
    if (!$('#prFecha').value){ aviso('#prMsg','bad','Elegí la fecha y la hora.'); return; }
    desde = new Date($('#prFecha').value).toISOString();
  }

  const btn = $('#btnPrGuardar'); btn.disabled = true;
  const { data, error } = await rpc('fijar_precios', {
    p_items: items, p_vigencia_desde: desde,
    p_nota: $('#prNota').value.trim() || null });
  btn.disabled = false;
  if (error){ aviso('#prMsg','bad', error.message); return; }

  NUEVOS = {};
  $('#prMasivo').value = ''; $('#prNota').value = '';
  aviso('#prMsg','ok', data.mensaje);
  await cargarPrecios();
  cargarProductos();
};

function pintarProgramados(){
  const f = PRECIOS.filter(p => p.precio_programado != null)
    .sort((a,b) => a.programado_desde.localeCompare(b.programado_desde));
  $('#tblProgramados').innerHTML = f.map(p => `
    <tr><td class="mono">${esc(p.codigo)}</td>
        <td>${esc(p.descripcion)}</td>
        <td class="num">${p.precio_vigente != null ? num(p.precio_vigente) : '—'}</td>
        <td class="num"><b>${num(p.precio_programado)}</b></td>
        <td>${esc(fecha(p.programado_desde))}</td>
        <td><div class="fila-acc"><button class="b b-sec"
             data-cancelar="${p.precio_programado_id}">Cancelar</button></div></td></tr>
  `).join('') || '<tr><td colspan="6" class="vacio">No hay ningún precio programado</td></tr>';

  $$('#tblProgramados button[data-cancelar]').forEach(b => b.onclick = async () => {
    limpiar('#progMsg');
    b.disabled = true;
    const { data, error } = await rpc('cancelar_precio_programado',
      { p_precio_id: Number(b.dataset.cancelar) });
    b.disabled = false;
    if (error){ aviso('#progMsg','bad', error.message); return; }
    aviso('#progMsg','ok', data.mensaje);
    cargarPrecios();
  });
}

// ---------- la lista pública ----------
async function cargarListaPublica(){
  const { data, error } = await pedir(sb.from('config').select('clave,valor')
    .in('clave', ['lista_publica.codigo','lista_publica.activa',
                  'lista_publica.titulo','precio.moneda']));
  //  Con la lectura caída también se desdice lo de arriba: un chip "activa"
  //  viejo afirmaría algo sobre el link público.
  if (error){
    aviso('#listaMsg','bad', error.message);
    $('#listaPub').innerHTML = `<div class="vacio">No se pudo leer cómo está la ` +
      `lista pública (${esc(error.message)}). No quiere decir que esté desactivada.</div>`;
    return false;
  }
  const cfg = Object.fromEntries((data||[]).map(r => [r.clave, r.valor]));
  const codigo = cfg['lista_publica.codigo'];
  const activa = cfg['lista_publica.activa'] === true;
  const url = `${location.origin}/lista?c=${codigo ?? ''}`;

  $('#listaPub').innerHTML = `
    <div class="grid">
      <label>Link para mandar por WhatsApp
        <input id="lpUrl" readonly value="${esc(url)}"></label>
      <div class="fila-acc" style="gap:0.471rem;flex-wrap:wrap">
        <button class="b b-sec" id="lpCopiar">Copiar</button>
        <button class="b b-sec" id="lpAbrir">Abrir</button>
        <button class="b b-sec" id="lpActivar">${activa ? 'Desactivar' : 'Activar'}</button>
        <button class="b b-sec" id="lpRotar">Rotar el código</button>
        <span class="chip ${activa ? 'c-ok' : 'c-warn'}">${activa ? 'activa' : 'desactivada'}</span>
        <span class="hint">precios en ${esc(cfg['precio.moneda'] ?? 'USD')}</span>
      </div>
    </div>`;

  $('#lpCopiar').onclick = async () => {
    try { await navigator.clipboard.writeText(url); aviso('#listaMsg','ok','Link copiado.'); }
    catch { $('#lpUrl').select(); aviso('#listaMsg','warn','Copialo a mano: quedó seleccionado.'); }
  };
  $('#lpAbrir').onclick = () => window.open(url, '_blank');

  $('#lpActivar').onclick = async () => {
    limpiar('#listaMsg');
    const { error } = await escribir(sb.from('config').update({ valor: !activa })
      .eq('clave','lista_publica.activa'));
    //  Si la base no contestó, la lista quizá ya cambió (D92): se relee para ver
    //  el estado real antes de volver a tocar (escribe el valor, no lo invierte).
    if (noContesto(error)){
      const releida = await cargarListaPublica();
      aviso('#listaMsg','warn', error.message + (releida
        ? ' Fijate arriba cómo quedó.'
        : ' Y tampoco se pudo releer cómo quedó: volvé a entrar a la pestaña ' +
          'antes de tocarla de nuevo.'));
      return;
    }
    if (error){ aviso('#listaMsg','bad', error.message); return; }
    cargarListaPublica();
  };

  $('#lpRotar').onclick = async () => {
    limpiar('#listaMsg');
    if (!confirm('El link que ya mandaste va a dejar de funcionar. ¿Rotamos el código?')) return;
    const { error } = await rpc('rotar_codigo_lista_publica');
    if (error){ aviso('#listaMsg','bad', error.message); return; }
    aviso('#listaMsg','ok','Código rotado. El link viejo ya no abre.');
    cargarListaPublica();
  };
  //  Devuelve si se leyó: el botón de activar lo necesita para saber qué decir.
  return true;
}
